<mat-divider class="divider" style="margin: {{ params.margin || '0.5' }}rem 0"></mat-divider>
